import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <UpdatesSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <FeaturesSection />
        <AboutSection />
        <RankingSection />
        <FaqSection />
        <IndexSection />
        <AppSection />
        <CommentsSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}